// extracted by mini-css-extract-plugin
export default {"Paginator":"Paginator_Paginator__bPxwi","paginateButton":"Paginator_paginateButton__K-W7P"};